module.exports = __webpack_public_path__ + "static/media/studio 4 station clean accessories organised work of arts.1280x960.c48adfb2.webp";